export default __webpack_public_path__ + "static/media/16.59c6cabc.png";